import { createSlice } from '@reduxjs/toolkit';

import resetStore from '../resetStore';

const initialState = {
  comment: '',
  status: 'CREATED',
  need_delivery: null,
  plan_delivery_date: '',
  time_min: '',
  time_max: '',
  address: {
    name: '',
    last_name: '',
    phone: '',
    full_address: '',
    floor: null,
    intercom: '',
    elevator_type: '',
  },
  grms: [],
  pass: {
    name: '',
    car_num: '',
  },
  stickers: [],
};

const refundFormSlice = createSlice({
  name: 'refundForm',
  initialState,
  reducers: {
    updateForm(state, action) {
      return {
        ...state,
        ...action.payload,
        address: {
          ...state.address,
          ...action.payload.address,
        },
      };
    },
    setStickersSlice(state, action) {
      state.stickers = action.payload;
    },
    resetForm() {
      return initialState;
    },
    setGrmsRefundForm(state, action) {
      state.grms = state.grms.concat(action.payload.grms);
      console.log(state.grms, 'woork');
    },
    setComment(state, action) {
      console.log(action.payload);
      state.comment = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState);
  },
});

export const { updateForm, resetForm, setGrmsRefundForm, setComment, setStickersSlice } =
  refundFormSlice.actions;
export default refundFormSlice.reducer;
